import {
  UPDATE_RISK_LIST_SUCCESS,
  UPDATE_RISK_LIST_FAILED,
  RESET_UPDATE_RISK_LIST,
  LOADING_UPDATE_RISK_LIST,
  NETWORK_ERROR_UPDATE_RISK_LIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATE_RISK_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATE_RISK_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATE_RISK_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATE_RISK_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATE_RISK_LIST:
      return (state = initialState);
    default:
      return state;
  }
};
